import type { XAxisTickContentProps } from 'recharts';
import { Customized, Text } from 'recharts';

/**
 * CustomXAxis component for displaying the X-axis in a chart.
 * @param displayShortMonth - Optional flag to display a shortened month value.
 * @returns - The rendered component.
 */
export const CustomXAxis = ({ x, y, payload: { offset, value } }: XAxisTickContentProps) => {
  const chartWidth = Number(offset);
  const rotateLabels = chartWidth < 30 && chartWidth !== 0;
  const textWidth = rotateLabels ? 120 : chartWidth > 100 ? chartWidth : Math.min(chartWidth * 2.5, 120);
  return (
    <CustomizedTextWithTooltip
      x={x as number}
      y={y as number}
      textWidth={textWidth}
      rotateLabel={rotateLabels}
      value={value}
    />
  );
};

export const XAxisLineChart = ({ x, y, payload, visibleTicksCount, index }: XAxisTickContentProps) => {
  const rotateLabels = visibleTicksCount > 8;
  const textWidth = rotateLabels || visibleTicksCount - 1 === index ? 120 : 150;
  return (
    <CustomizedTextWithTooltip
      x={x as number}
      y={y as number}
      textWidth={textWidth}
      rotateLabel={rotateLabels}
      value={payload.value}
    />
  );
};

type TextElWithTooltipType = {
  value?: string;
  x: number;
  y: number;
  rotateLabel: boolean;
  textWidth: number;
};

const getAttributeFromCondition = <T,>(conditon: boolean, first: T, second: T): T => {
  return conditon ? first : second;
};
const CustomizedTextWithTooltip = ({ value, x, y, rotateLabel, textWidth }: TextElWithTooltipType) => {
  return value ? (
    <Customized
      component={
        <>
          <title>{value}</title>
          <Text
            x={x}
            y={y}
            fontSize={getAttributeFromCondition(rotateLabel, 8, 10.5)}
            verticalAnchor="start"
            textAnchor={getAttributeFromCondition(rotateLabel, 'end', 'middle')}
            angle={getAttributeFromCondition(rotateLabel, -40, 0)}
            width={textWidth}
            maxLines={getAttributeFromCondition(rotateLabel, 1, 2)}
          >
            {value}
          </Text>
        </>
      }
    />
  ) : (
    <></>
  );
};
